import React from 'react';
import Switch from '../Switch/Switch';
import './AssignmentGrid.css';

const defaultGetId = (item) => (item && typeof item === 'object' ? item.id : item);
const defaultGetLabel = (item) => (item && typeof item === 'object' ? item.name : item);

const AssignmentGrid = ({
  label,
  icon,
  items = [],
  selectedIds = [],
  onToggle,
  onSelectAll,
  switchName = 'item_ids',
  getId = defaultGetId,
  getLabel = defaultGetLabel,
}) => {
  return (
    <div className="col-md-12">
      {label && (
        <div className="assignment-grid-label">
          {icon}
          <span>{label}</span>
        </div>
      )}
      <div className="assignment-grid-panel">
        <div className="assignment-grid-select-all-row">
          <Switch
            label="Select All"
            value="1"
            name="all"
            id={`select-all-${switchName}`}
            checked={items.length > 0 && selectedIds.length === items.length}
            onChange={onSelectAll}
          />
          <span className="small text-muted">{selectedIds.length} of {items.length} selected</span>
        </div>
        <div className="assignment-grid-items">
          {items.map((item, idx) => {
            const id = getId(item);
            return (
              <div className="assignment-grid-item" key={idx}>
                <Switch
                  label={getLabel(item)}
                  id={`${switchName}-${id}`}
                  name={switchName}
                  value={id}
                  checked={selectedIds.includes(id.toString())}
                  onChange={onToggle}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AssignmentGrid;
